export const GET_MAP_TAGGING_TASKS = /* GraphQL */ `
  query GetMapTaggingTasks($mapId: String!) {
    getMapTaggingTasks(mapId: $mapId) {
      data {
        id
        type
        resourceId
        mapContractId
        accountId
        productCode
        status
        assignedTo
        createdDate
        completedDate
        notes
      }
      error {
        message
      }
    }
  }
`
